const mode = (light, dark) => (props) => (props.colorMode === 'dark' ? dark : light);

export default {
  global: (props) => ({
    body: {
      bg: mode('white', '#080e1d')(props),
    },
  }),
};
